import { Grid, Typography } from "@mui/material";
import { FunctionComponent } from "react";
import { FeatureType, PlanModel } from "../../models/plans.model";
import { appNote, buttonLabels } from "../shared/constants";
import GridOptions from "../shared/grid-options.component";
import PlanFeature from './plan-feature.component';
import ButtonComponent from "../shared/button/button.component";
import { DuplicateIcon, EditIcon, HideIcon, TrashIcon, UnhideIcon } from "../../icon";

interface Props extends PlanModel {
    DisplayYearlyPrice: boolean;
    OpenConfirmPlanDialog?: (id: string) => void;
    OpenDisablePlanDialog?: (id: string) => void;
    OpenEditPlan?: (id: string) => void;
    ShowAddOnOptions: boolean;
    HideBuyNow?: boolean;
    OnClick?: () => void;
    Duplicate?: (id: string) => void;
    IsLoading?: boolean;
    IsSignUp?: boolean;
    Index: number;
    IsMobileDevice?: boolean;
}

const PlanCardComponent: FunctionComponent<Props> = (props) => {
    return <Grid xl={props.IsSignUp ? 12 : 3} lg={props.IsSignUp ? 12 : 3} md={props.IsSignUp ? 12 : 6} sm={props.IsSignUp ? 12 : 8} item className='my-2 mx-4'>
        <div className={`${props.IsDeleted ? 'plan-card-inactive box-shadow-display-background-shadow' :
            `plan-card box-shadow-display-background-shadow ${(props.Index % 2 === 1) ? "bg-color-primary-light" : "bg-color-secondary"} 
        `} p-relative`}>
            {props.ShowAddOnOptions && <div className='p-absolute r-1 t-3'>
                <GridOptions
                    data={
                        [
                            {
                                btnName: "Edit",
                                btnColor: "primary",
                                onClickbtn: () => { if (props.OpenEditPlan) { props.OpenEditPlan(props.PlanID) } },
                                btnIcon: EditIcon
                            },
                            {
                                btnName: props.IsDeleted ? "Unhide" : "Hide",
                                btnColor: props.IsDeleted ? "secondary" : "primary",
                                onClickbtn: () => { if (props.OpenDisablePlanDialog) { props.OpenDisablePlanDialog(props.PlanID) } },
                                btnIcon: props.IsDeleted ? UnhideIcon : HideIcon
                            },
                            {
                                btnName: "Duplicate",
                                btnColor: "primary",
                                onClickbtn: () => props.Duplicate && props.Duplicate(props.PlanID),
                                btnIcon: DuplicateIcon
                            },
                            {
                                btnName: "Delete", btnColor: "primary",
                                onClickbtn: () => { if (props.OpenConfirmPlanDialog) { props.OpenConfirmPlanDialog(props.PlanID) } },
                                btnIcon: TrashIcon
                            }
                        ]}
                    IsTiers={(props.Index % 2 === 1)}
                    DisabledIcon={props.IsDeleted}
                /></div>}
            <div >
                {
                    props.DisplayYearlyPrice ?
                        <span className='my-auto'>
                            <span className={`${props.IsMobileDevice ? 'h1' : 'h2-bold'} f-w-bold mr-1 ${props.IsDeleted ? 'color-primary-accent' : (props.Index % 2 === 1) ? 'color-secondary' : ''}`}>${props.YearlyPrice}</span>
                            <span className={`${props.IsMobileDevice ? 'h1' : 'h2-bold'} f-w-bold`}>
                                <span className={`${props.IsDeleted ? 'color-primary-accent' : (props.Index % 2 === 1) ? 'color-secondary' : 'color-plans-text'} plan-price`}>{props.Price !== 0 ? `$${props.Price}` : appNote.FREE}</span>
                                <span className={`${props.IsMobileDevice ? 'h2' : 'h6'}  ${props.IsDeleted ? 'color-plans-text' : (props.Index % 2 === 1) ? 'color-secondary' : 'color-plans-text'}`}>/ Month</span>
                            </span>
                        </span> :
                        <span className={`${props.IsMobileDevice ? 'h2-semibold' : 'h2-bold'} ${props.IsDeleted ? 'color-primary-accent' : (props.Index % 2 === 1) ? 'color-secondary' : 'color-add-on-text '} f-w-bold my-auto`}>{props.Price !== 0 ? `$${props.Price}` : appNote.FREE}
                            <span className={`${props.IsMobileDevice ? 'h2' : 'h6'} ${props.IsDeleted ? 'color-plans-text' : (props.Index % 2 === 1) ? 'color-secondary' : 'color-plans-text'} `}>/ Month</span>
                        </span>
                }
            </div>
            <Typography className={` ${props.IsMobileDevice ? 'h1' : 'h2-semibold'} w-break mb-1 t-align-left mt-2 ${props.IsDeleted ? 'color-primary-accent' : (props.Index % 2 === 1) ? 'color-secondary' : ''}`}>{props.Name}</Typography>
            <div className={`mb-2 bb-primary-divider-4 pb-2`}>
                {
                    props.Features.filter(x => x.Type === FeatureType.MAIN).sort((x) => x.DisplayOrder).map((y, i) => <Typography key={i} className={` ${props.IsMobileDevice ? 'h4' : 'h5-regular'} ${props.IsDeleted ? 'color-primary-accent' : (props.Index % 2 === 1) ? 'color-secondary' : 'color-primary-accent'}`}>{y.Label}</Typography>)
                }
            </div>

            <div className={`w-break ${props.IsDeleted ? 'bg-color-plans-inactive' : 'plan-features'}`}>
                <Typography className={`${props.IsMobileDevice ? 'h4' : 'h5-regular'} mb-1 ${props.IsDeleted ? 'color-primary-accent' : (props.Index % 2 === 1) ? 'color-secondary' : ''}`}>{appNote.ADDITIONAL_FEATURES}:</Typography>
                {
                    props.Features.filter(x => x.Type === FeatureType.ADDITIONAL).sort((x) => x.DisplayOrder).map((x, i) => <div key={i} className={`${props.IsMobileDevice ? 'mb-1' : ''}`}><PlanFeature Feature={x.Label} Index={props.Index} DisabledIcon={props.IsDeleted} /></div>)
                }
            </div>

            {props.Features.filter(x => x.Type === FeatureType.PURCHASE).length > 0 &&
                <>
                    <div className='mt-2'>
                        <Typography className={`${props.IsMobileDevice ? 'h4' : 'h5-regular'} mb-1 ${props.IsDeleted ? 'color-primary-accent' : (props.Index % 2 === 1) ? 'color-secondary' : ''}`}>{appNote.ADDITIONAL_PURCHASES}:</Typography>
                    </div>
                    {props.Features.filter(x => x.Type === FeatureType.PURCHASE).sort((x) => x.DisplayOrder).map((y, i) => <Typography key={i} className={`${props.IsMobileDevice ? ' h4' : 'h5 - regular'} mb-1`} > {y.Label}</Typography>)}
                </>
            }
            <div className={'foot-note'} style={{ position: "absolute" }}>
                {props.Footnote && <div className='t-align-left'>
                    <Typography className={`${props.IsMobileDevice ? 'h4' : 'h5-regular'} w-break mb-1 ${props.IsDeleted ? 'color-primary-accent' : (props.Index % 2 === 1) ? 'color-secondary' : ''} `} gutterBottom>{props.Footnote}</Typography>
                </div>}

                {!props.HideBuyNow &&
                    <ButtonComponent ButtonLabel={buttonLabels.BUY_NOW} Variant={"primary-btn"} ClassName={`mt-2 ${props.IsMobileDevice ? 'h2' : 'h4-regular'} w-p-100 justify-center br-6 ${(props.Index % 2 === 1) ? 'add-on-secondary-btn-hover' : 'add-on-primary-btn-hover'}`} OnClick={() => props.OnClick && props.OnClick()} />
                }
            </div>
        </div>
    </Grid >
}

export default PlanCardComponent;
